import sibling from "./sibling";
import selectOption from "./selectOption";

export default function(controller, direction) {
  const siblingValue = direction === "down";
  const item = sibling(siblingValue, controller.options, controller.selectedOption);
  if (item) selectOption(controller, item);
}
